import React from "react";
import IconBook from "assets/img/icon-sosmed/icon_book.png";
import IconAward from "assets/img/icon-sosmed/icon_sertifikasi.png";
import IconUserGroup from "assets/img/icon-sosmed/icon_user_group.png";
import IconInovasi from "assets/img/icon-sosmed/icon_inovasi.png";

const features = [
  {
    title: "Platform Terintegrasi",
    description: "Sistem terpadu untuk guru, siswa, dan orang tua",
    icon: IconUserGroup,
  },
  {
    title: "Materi Berkualitas",
    description: "Konten pembelajaran sesuai kurikulum madrasah",
    icon: IconBook,
  },
  {
    title: "Sertifikasi Digital",
    description: "Pelatihan dan sertifikasi untuk guru",
    icon: IconAward,
  },
  {
    title: "Inovasi Berkelanjutan",
    description: "Update fitur dan Materi secara berkala",
    icon: IconInovasi,
  },
];

export default function ProgramDiajeng() {
  return (
    <section className="bg-black px-5 py-16 font-['Inter',sans-serif] text-white sm:px-8 sm:py-20 lg:px-14 lg:py-24">
      <div className="mx-auto w-full max-w-[1680px]">
        <div className="mx-auto max-w-6xl text-center">
          <p className="text-sm font-semibold uppercase tracking-normal text-[#007B0E] sm:text-base lg:text-lg">
            MENGAPA MEMILIH DIAJENG SEBAGAI PLATFORM PEMBELAJARAN ?
          </p>

          <h2 className="mt-7 text-[25px] font-semibold leading-[1.08] tracking-normal text-[#0a1f1a] sm:text-5xl md:text-5xl lg:text-[35px]">
            Solusi Digital Terpadu untuk Madrasah Modern
          </h2>

          <p className="mx-auto mt-5 max-w-7xl text-base font-regular leading-snug text-[#8c8c8c] sm:text-xl md:text-xl lg:text-[18px]">
            Platform pembelajaran digital yang dirancang khusus untuk
            meningkatkan kualitas pendidikan madrasah di Jawa Tengah melalui
            integrasi teknologi dalam proses pembelajaran dan administrasi.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:mt-9 lg:grid-cols-4 lg:gap-7">
          {features.map(({ title, description, icon }) => (
            <article
              key={title}
              className="min-h-[196px] rounded-[12px] border border-[#CCCCCC] bg-[#F9FBFA] px-5 py-7 text-left text-[#171717] shadow-[0_1px_0_rgba(255,255,255,0.5)] sm:min-h-[210px] sm:px-6 lg:min-h-[224px] lg:px-5 xl:px-6"
            >
              <div className="flex h-[59px] w-[59px] items-center justify-center text-white">
                <img
                  src={icon}
                  alt=""
                  aria-hidden="true"
                  className="h-[50px] w-[50px] object-contain"
                />
              </div>

              <h3 className="mt-4 text-[20px] font-['Plus_Jakarta_Sans',sans-serif] font-semibold leading-tight tracking-normal sm:text-lg lg:text-[24px]">
                {title}
              </h3>

              <p className="mt-3 text-base font-regular font-['Inter', sans-serif] leading-relaxed text-[#6B7280] sm:text-md lg:text-[18px]">
                {description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
